import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentType } from '../models/ContentType';
import { SortSelection } from '../models/SortSelection';
import { Location } from '../../common/utils/Location';
import * as queryString from 'query-string';
import { ContentTypeFilterAllOption, ContentTypeFilterValue } from '../models/ContentTypeFilterValue';

/**
 * When switching content types we want to persist the sort option if possible, but if it is an invalid sort option it must be replaced with the default
 */
export function getValidSortClause(contentType: ContentType, sort?: SortSelection): SortSelection {
  if (sort) {
    // use the provided sort if the content type supports it,
    // otherwise provide an appropriate fallback.
    return (
      ContentDefinitions[contentType].getSortOptions().find((s) => s.name === sort.name) ||
      ContentDefinitions[contentType].getSortOptions()[0]
    );
  }
  // no sort option given so use default
  return ContentDefinitions[contentType].getSortOptions()[0];
}

/**
 * When loading the page for the first time we want to parse any sort options from the url, but restrict them to the sortOptions specific to a content type.
 * Why?  The content types may have different fields sent to CRASS for sorting but are presented as the same field to the user (i.e. Table popularity uses
 * downstreamWorkbookCount and Views popularity uses a different field from CRASS)
 */
export function getSortSelectionFromUrl(
  contentType?: ContentTypeFilterValue,
  sortByListForContentType?: SortSelection[]
): SortSelection | undefined {
  const query = Location.hash().split('?')[1];
  const orderByInUrl = query ? queryString.parse(query)['order_by'] : undefined;
  const sortList =
    contentType && contentType !== ContentTypeFilterAllOption
      ? ContentDefinitions[contentType as ContentType].getSortOptions()
      : sortByListForContentType;
  return sortList && orderByInUrl ? sortList.find((x) => x.name === orderByInUrl.split(':')[0]) : undefined;
}
